module.exports = __webpack_public_path__ + "static/media/download.d9e72eab.svg";